<template>
  <div
    v-loading.fullscreen.lock="mainLoader"
    class="members-page body__content"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <div class="search-section">
      <div class="container">
        <el-row>
          <el-col :sm="24">
            <h1>Search the community network</h1>
            <div class="search-btn-container hidden-sm-and-down">
              <ul class="search-buttons mt-4">
                <li
                  v-for="(sort, index) in individualsType"
                  :key="index"
                >
                  <el-button
                    :class="{ 'active-state': search.sortBy == sort.name }"
                    class="search-btn"
                    @click="handleSortChange(sort)"
                  >
                    <p>{{ sort.label }}</p>
                  </el-button>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <el-form
          id="searchForm"
          ref="searchForm"
          :model="search"
          @submit.native.prevent
        >
          <el-row>
            <el-col
              :sm="24"
              :md="12"
            >
              <el-form-item
                label="Keyword search"
                prop="keyword"
                class="hidden-sm-and-down"
              >
                <el-input
                  id="keyword"
                  v-model="search.keyword"
                  :placeholder="`${MembersSelected ? 'Search for name, expertise...' : 'Search for name, locality, service...'}`"
                  auto-complete="no"
                  maxlength="255"
                  @keyup.enter.native="searchMembers"
                />
              </el-form-item>
              <el-form-item
                label=""
                prop="keyword"
                class="hidden-md-and-up"
              >
                <el-input
                  id="keyword"
                  v-model="search.keyword"
                  :placeholder="`${MembersSelected ? 'Search for name, expertise...' : 'Search for name, locality, service...'}`"
                  auto-complete="no"
                  maxlength="255"
                  @keyup.enter.native="searchMembers"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col
              :sm="24"
              :md="12"
            >
              <div class="search-members">
                <el-button
                  class="search-members-button"
                  type="primary"
                  @click="searchMembers"
                >
                  Search
                </el-button>
              </div>
            </el-col>
          </el-row>
          
          <el-row class="hidden-sm-and-down">
            <el-col
              v-if="MembersSelected"
              :sm="24"
              :md="12"
            >
              <el-form-item
                prop="expertise"
                class="is-no-asterisk"
              >
                <template slot="label">
                  <p>Expertise</p>
                  <span class="sr-only">Please select an expertise</span>
                </template>
                <v-select
                  v-model="search.expertise"
                  placeholder="Choose from the following"
                  :options="expertises"
                  :searchable="true"
                  :clearable="false"
                  :reduce="(expertise) => expertise.id"
                  input-id="expertise"
                  autocomplete="false"
                  label="name"
                  class="half-content"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="!MembersSelected"
              :sm="24"
              :md="9"
            >
              <el-form-item
                prop="locality"
                class="is-no-asterisk"
              >
                <template slot="label">
                  <p>Locality</p>
                  <span class="sr-only">Please select a locality</span>
                </template>
                <v-select
                  v-model="search.locality"
                  placeholder="Choose from the following"
                  :options="localities"
                  :searchable="true"
                  :clearable="false"
                  :reduce="(locality) => locality.id"
                  input-id="locality"
                  autocomplete="false"
                  label="name"
                  class="half-content"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="!MembersSelected"
              :sm="24"
              :md="9"
            >
              <el-form-item
                prop="service"
                class="is-no-asterisk"
              >
                <template slot="label">
                  <p>Service</p>
                  <span class="sr-only">Please select a service</span>
                </template>
                <v-select
                  v-model="search.service"
                  placeholder="Choose from the following"
                  :options="services"
                  :searchable="true"
                  :clearable="false"
                  :reduce="(service) => service.id"
                  input-id="locality"
                  autocomplete="false"
                  label="name"
                  class="half-content"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="d-flex"
              :sm="24"
              :md="MembersSelected ? 12 : 6"
            >
              <el-button
                type="text"
                class="reset-btn"
                @click="resetSearch"
              >
                Reset
              </el-button>
              <el-button
                type="primary"
                class="update-results-btn"
                @click="searchMembers"
              >
                Update results
              </el-button>
            </el-col>
          </el-row>
          <el-row class="hidden-md-and-up">
            <el-col :sm="24">
              <el-form-item
                prop="title"
                class="is-no-asterisk"
              >
                <template slot="label">
                  <span aria-hidden="true">View</span>
                  <span class="sr-only">Please select a view type</span>
                </template>
                <v-select
                  v-model="search.sortBy"
                  :value="search.sortBy"
                  placeholder="Choose from the following"
                  :options="viewOptions"
                  :searchable="false"
                  :clearable="false"
                  :reduce="(viewOption) => viewOption.key"
                  input-id="view"
                  autocomplete="false"
                  class="half-content"
                  @input="searchMembers"
                />
              </el-form-item>
            </el-col>
            <el-col
              :sm="24"
              class="hidden-md-and-up"
            >
              <el-button
                class="more-filters-btn"
                size="medium"
                @click="openMembersFilter"
              >
                More filters
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div
      v-if="showZeroData"
      class="zero-data text-center my-5"
    >
      <div class="container">
        <el-row>
          <el-col :sm="24">
            <p>
              We could not find any {{ MembersSelected ? 'members' : 'organisations' }} with your search criteria. Please
              update your search and try again.
            </p>
          </el-col>
        </el-row>
      </div>
    </div>

    <div
      v-if="!showZeroData"
      id="view-by"
      class="container view-by-section mt-2"
    >
      <el-form>
        <el-row>
          <el-col
            :sm="24"
            :md="12"
            :lg="12"
          >
            <el-form-item
              prop="title"
              class="is-no-asterisk"
            >
              <template slot="label">
                <span
                  aria-hidden="true"
                  class="font-weight-bold"
                >Sort Results</span>
                <span class="sr-only">Please select sorting</span>
              </template>
              <v-select
                v-model="sortResult"
                placeholder="Choose from the following"
                :options="sortResults"
                :searchable="true"
                :clearable="false"
                input-id="sortResult"
                autocomplete="false"
                label="name"
                class="half-content"
              />
            </el-form-item>
          </el-col>
          <el-col
            :sm="24"
            :md="12"
            :lg="12"
          >
            <div class="results-text">
              Results <span>{{ totalResults }}</span>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div
      v-if="members.length"
      class="results-section"
    >
      <div class="container">
        <div class="mt-4">
          <el-row class="card-deck">
            <component
              :is="MembersSelected ? 'member-card' : 'organisation-card'"
              v-for="(member, index) in members"
              :key="index"
              :member="member"
              :organisation="member.organisation"
            />
          </el-row>
        </div>
      </div>

      <div class="pagination-help-section">
        <div class="container">
          <el-card class="help-card">
            <p class="">
              Can’t find the right person? We can help you find the support you
              need.
              <a
                :href="contactUsUrl"
                aria-label="Click to open contact form in a new tab"
                class="se-tel"
              >
                Get in touch
              </a>
            </p>
          </el-card>
          <el-button
            v-if="!onLastPage"
            class="load-more-btn"
            size="medium"
            @click="fetchMembers"
          >
            Load more
          </el-button>
        </div>
      </div>
    </div>
    <members-filter
      v-if="membersFilterOpen"
      v-model="search"
      :services="services"
      :localities="localities"
      :expertises="expertises"
      :members-selected="MembersSelected"
      @close="closeMembersFilter"
      @search="searchMembers(true)"
      @reset="resetSearch(true)"
    ></members-filter>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../../store";
import gsApi from "@/services/gs.api";
import MemberCard from "@/components/platform/members/member-card";
import OrganisationCard from "@/components/platform/organisations/organisation-card";
import MembersFilter from "@/components/slide-panel/panels/members-filter";
import _ from "lodash";

export default {
  name: "MembersPage",
  metaInfo: {
    title: "Members",
  },
  components: {
    "member-card": MemberCard,
    "members-filter": MembersFilter,
    OrganisationCard
  },
  data() {
    return {
      mainLoader: false,
      page: 1,
      perPage: 8,
      totalResults: 0,
      showZeroData: false,
      onLastPage: false,
      search: {},
      viewOptions: [
        {
          key: "Individual",
          label: "Members",
        },
        {
          key: "Organisation",
          label: "Organisations",
        },
      ],
      members: [],
      expertises: [],
      localities:[],
      services:[],
      membersFilterOpen: false,
      individualsType: [
        { label: "Members", name: "Individual" },
        { label: "Organisations", name: "Organisation" },
        
      ],
      currentZoom: 2,
      currentBounds: null,
      sortMembersResults: [
        { id: 1, name: "A-Z first name", order_by: "first_name", order: "asc" },
        { id: 2, name: "Z-A first name", order_by: "first_name", order: "desc" },
        { id: 3, name: "A-Z Surname", order_by: "last_name", order: "asc" },
        { id: 4, name: "Z-A Surname", order_by: "last_name", order: "desc" },
        {
          id: 5,
          name: "Most recently joined date",
          order_by: "created_at",
          order: "desc",
        },
        {
          id: 6,
          name: "Oldest joined date",
          order_by: "created_at",
          order: "asc",
        }
      ],
      sortOrganisationsResults:[
        { id: 1, name: "A-Z Organisation Name", order_by: "organisation_name", order: "asc" },
        { id: 2, name: "Z-A Organisation Name", order_by: "organisation_name", order: "desc" },
        {
          id: 3,
          name: "Most recently joined date",
          order_by: "created_at",
          order: "desc",
        },
        {
          id: 4,
          name: "Oldest joined date",
          order_by: "created_at",
          order: "asc",
        }
      ],
      sortResult: null,
    };
  },
  computed: {
    ...mapState(["user"]),
    MembersSelected(){
      return this.search.sortBy == 'Individual'
    },
    sortResults()
    {
      return this.MembersSelected ? this.sortMembersResults : this.sortOrganisationsResults
    },
    contactUsUrl(){
      return `${process.env.VUE_APP_BE_WELL_CMS_URL}/for-my-organisation/contact-us-cwb`
    }
  },

  watch: {
    search: {
      handler(val) {
        let params = _.pickBy(val, function (o) {
          return o !== null && o !== undefined;
        });
        this.addParamsToLocation(params);
      },
      deep: true,
    },

    sortResult(val) {
      this.search.order_by = val.order_by;
      this.search.order = val.order;
      this.searchMembers();
    },
  },
  created() {
    let search = {
      sortBy: this.$store.state.search.sortBy,
      keyword: this.$store.state.search.keyword,
      expertise: this.$store.state.search.expertise,
      view: this.$store.state.search.view,
      order_by: this.$store.state.search.order_by,
      order: this.$store.state.search.order,
    };

    if (this.$route.query.hasOwnProperty("sortBy")) {
      search.sortBy = this.$route.query.sortBy;
    }
    if (this.$route.query.hasOwnProperty("keyword")) {
      search.keyword = this.$route.query.keyword;
    }
    if (this.$route.query.hasOwnProperty("expertise")) {
      search.expertise = parseInt(this.$route.query.expertise);
    }
    if (this.$route.query.hasOwnProperty("view")) {
      search.view = "list";
    }
    if (this.$route.query.hasOwnProperty("order_by")) {
      search.order_by = this.$route.query.order_by;
    }
    if (this.$route.query.hasOwnProperty("order")) {
      search.order = this.$route.query.order;
    }
    if (this.$route.query.hasOwnProperty("locality")) {
      search.locality = this.$route.query.locality;
    }
    if (this.$route.query.hasOwnProperty("service")) {
      search.service = this.$route.query.service;
    }
    this.search = search;
    if (store.state.user.isLogged) {
      this.getRegisterMeta();
    }
  },
  methods: {
    addParamsToLocation(params) {
      history.pushState(
        {},
        null,
        this.$route.path +
          "?" +
          Object.keys(params)
            .map((key) => {
              return (
                encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
              );
            })
            .join("&")
      );
    },
    getRegisterMeta() {
      this.mainLoader = true;

      gsApi.globalscot.meta
        .index()
        .then((response) => {
          this.expertises = response.data.expertises.data;
          this.localities = response.data.localities.data;
          this.services = response.data.services.data;
          this.fetchMembers();
        })
        .catch(() => {
          this.mainLoader = false;
          this.$alert(
            "An unknown error occurred. Please try again later.",
            "Error",
            {
              confirmButtonText: "Close",
              showClose: false,
              customClass: "notification-modal",
            }
          );
        });
    },
    resetSearch(isMobile) {
      if (isMobile) {
        this.closeMembersFilter();
      }

      this.search = {
        sortBy: this.search.sortBy,
        keyword: "",
        expertise: null,
        service: null,
        locality:null,
        //view: "list",
        order_by: "",
        order: "",
      };

      this.sortResult = null;

      this.searchMembers();
    },
    searchMembers(isMobile) {
      if (isMobile) {
        this.closeMembersFilter();
      }

      this.page = 1;
      this.totalResults= 0;
      this.members = [];

      this.fetchMembers();
    },
    fetchMembers() {
      if (!this.mainLoader) {
        this.mainLoader = true;
      }

      this.$store.commit("UPDATE_MEMBER_SEARCH", this.search);

      let params = {
        page: this.page,
        per_page: this.perPage,
        member_type: this.search.sortBy,
        expertise: this.search.expertise,
        locality: this.search.locality,
        service: this.search.service,
        search: this.search.keyword != '' ? this.search.keyword : null ,
        order_by: this.search.order_by != "" ? this.search.order_by : null,
        order: this.search.order != '' ? this.search.order : null,
      };

      gsApi.members
        .search(params)
        .then((response) => {
          this.mainLoader = false;
          this.totalResults = response.data.meta.pagination.total;

          if (
            response.data.meta.pagination.current_page !==
            response.data.meta.pagination.total_pages
          ) {
            this.onLastPage = false;
            this.page++;
          } else {
            this.onLastPage = true;
          }

          // workaround to avoid showing duplicate members
          const currentMembers = _.map(this.members, "id");

          this.members = this.members.concat(
            response.data.data.filter((el) => {
              return !currentMembers.includes(el.id);
            })
          );

          this.showZeroData = this.members.length > 0 ? false : true;
        })
        .catch(() => {
          this.mainLoader = false;
        });
    },
    openMembersFilter() {
      this.membersFilterOpen = true;
    },
    closeMembersFilter() {
      this.membersFilterOpen = false;
    },
    handleSortChange(sort) {

      this.search.sortBy = sort.name
      this.search.page = 1
      this.sortResult = null;
      this.search.order_by = ""
      this.search.order =  ""

      if(sort.name == "Individual"){
        this.search.service = null
        this.search.locality = null
      }else{
        this.search.expertise = null
      }
      this.searchMembers();
    },
  },
};
</script>
<style>
.map-list-btn {
  list-style: none;
  display: inline-flex;
}
</style>
